import {createSelector} from '@ngrx/store';

import * as fromCitizensReducer from './citizens-services.reducer';
import {AppState} from 'src/app/store/reducers';
import {CitizensServices} from './citizens-services.model';

export const currentState = (state: AppState) =>
  state[fromCitizensReducer.citizensServicesesFeatureKey];

export const selectAllCitizens = createSelector(
  currentState,
  fromCitizensReducer.selectAll
);

export const selectTotolCitizen = createSelector(
  currentState,
  fromCitizensReducer.selectTotal
);

export const selectModifiedCitizensService = createSelector(
  selectAllCitizens,
  (citizens) => {
    return citizens.map((citizen) => {
      return {
        ...citizen,
        modServiceCategory: citizen?.serviceCategory?.categoryName,
        modInstitution: citizen?.serviceProvider?.institutionName
      };
    });
  }
);

export const selectModifiedCitizensByCategoryUniqueId = (
  categoryUniqueId: string
) =>
  createSelector(selectModifiedCitizensService, (categorys: CitizensServices[]) => {
    return categorys.filter(
      (category) =>
        category?.serviceCategory?.categoryUniqueId === categoryUniqueId
    );
  });


export const selectModifiedCitizensByServiceUniqueId = (serviceUniqueId: string) =>
  createSelector(selectModifiedCitizensService, (services: CitizensServices[]) => {
    return services.find(
      (service) => service?.serviceUniqueId === serviceUniqueId
    );
  });
